<template>
  <div class="welcome" v-if="!isLandingFirst">
    <span v-html="showWelcomeContent"></span>
  </div>

  <!--BUTTONS-->
  <div class="buttons">
    <QppButton :buttons="buttons"></QppButton>
  </div>
</template>

<script>
import store from "@/store";
import helper from "@/services/helper";
import QppButton from "@/components/common/QppButton";
import screenApiService from "@/services/screenApiService";
import {mapState} from "vuex";

export default {
  name: 'start',
  components: {QppButton},
  data() {
    return {
      buttons: [],
      screenProperties: {}
    }
  },
  computed: {
    showWelcomeContent() {
      return this.$store.state.siteTheme.landingContent
    },
    ...mapState(['isLandingFirst'])
  },
  mounted() {
    store.commit('showModal', false);
    this.screenProperties = store.state.currentScreenProperties;
    this.buttons = store.state.currentScreenOptions;
    helper.sortByKey(this.buttons, 'sortOrder');
    if (document.readyState !== 'loading') {
      setTimeout(this.setlangAnimation, 50);
      setTimeout(this.addHandAnimation, 500);
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        setTimeout(this.setlangAnimation, 50);
        setTimeout(this.addHandAnimation, 500);
      });
    }

    if (this.isLandingFirst) screenApiService.showPopup();
  },
  beforeUnmount() {
    screenApiService.resetPopup();
  },
  methods: {
    setlangAnimation() {
      let firstButton = document.getElementsByClassName('lang-button');
      if (firstButton && firstButton.length > 0) {
        let newAnimation = firstButton[0].classList.contains('new-animation')
        let parentButton = firstButton[0].parentElement;
        parentButton.classList.add('language-animation');
        if (newAnimation) {
          parentButton.classList.add('new-animation');
        }
      }
    },
    addHandAnimation() {
      let startIcon = document.getElementsByClassName('start-button');
      const elem = document.createElement('i');
      if (startIcon && startIcon.length > 0) {
        let parentButton = startIcon[0].parentElement;
        elem.classList.add("fa", "fa-hand-point-right", 'fa-3x', 'text-color', "hand-pointer-start");
        if (parentButton)
          parentButton.prepend(elem)
      }
    }
  }
}
</script>
